import React from 'react';
import {IndexRedirect, Route} from 'react-router';
import {loadable} from 'lib/loadable/route';

const SubjectManager = loadable(() => import('./SubjectManager/SubjectManager.react'));
const SubjectSearch = loadable(() => import('./SubjectSearch/SubjectSearch.react'));
const AuthoringSubject = loadable(() => import('./AuthoringSubject/AuthoringSubject.react'));
const AuthoringSubjectEditor = loadable(() =>
  import('./AuthoringSubject/AuthoringSubjectEditor/AuthoringSubjectEditor.react')
);
const GuideEditor = loadable(() => import('./Guides/GuideEditor/GuideEditor.react'));

export function getDennisCreateNewSubjectPath() {
  return `/dennis/content/subjects/new`;
}

export function getDennisSubjectPathById(id, page = 'subject') {
  return `/dennis/content/subjects/${id}/${page}`;
}

export default (
  <Route component={SubjectManager} name='Subject Manager' path='subjects'>
    <IndexRedirect to='search' />
    <Route component={SubjectSearch} name='Subject Lookup' path='search' />
    <Route name='Subject Editor' path='new' component={AuthoringSubjectEditor} />
    <Route component={AuthoringSubject} path=':subjectId'>
      <IndexRedirect to='subject' />
      <Route component={AuthoringSubjectEditor} name='Subject Editor' path='subject' />
      <Route component={GuideEditor} path='guides(/:guideType)' />
    </Route>
  </Route>
);
